import * as actionTypes from './actionTypes'
import { providerService } from '../../service'
import { errorHelper } from '../../common/helpers'
import { constants } from '../../common/constants'

export function getProviders({ page = constants.GET_ALL_ITEMS, filter, reset } = {}) {
    return async (dispatch) => {
        try {
            if (reset == true) dispatch({ type: actionTypes.RESET_PROVIDERS })

            dispatch({ type: actionTypes.FETCH_PROVIDERS })

            const response = await providerService.getAll(page, filter)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_PROVIDERS_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_PROVIDERS_SUCCESS,
                payload: {
                    providers: data.data,
                    total: data.quantity,
                    pageSize: data.pageSize
                }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_PROVIDERS_FAILURE)
        }
    }
}
export function resetProviders() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_PROVIDERS
        })
    }
}
export function getProvider(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.RESET_PROVIDER })
            dispatch({ type: actionTypes.FETCH_PROVIDER })

            const response = await providerService.get(id)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_PROVIDER_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_PROVIDER_SUCCESS,
                payload: { provider: data }
            })

        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_PROVIDER_FAILURE)
        }
    }
}
export function resetProvider() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_PROVIDER
        })
    }
}

export function createProvider(provider, onSuccess) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.CREATE_PROVIDER })

            const response = await providerService.create(provider)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.CREATE_PROVIDER_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.CREATE_PROVIDER_SUCCESS,
                payload: {
                    provider: data
                }
            })


            dispatch({ type: actionTypes.RESET_CREATE_PROVIDER })

            onSuccess()
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.CREATE_PROVIDER_SUCCESS)
        }
    }
}
export function resetCreateProvider() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_CREATE_PROVIDER
        })
    }
}

export function updateProvider(id, provider, onSuccess) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.UPDATE_PROVIDER })

            const response = await providerService.update(id, provider)
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.UPDATE_PROVIDER_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.UPDATE_PROVIDER_SUCCESS,
                payload: { provider: data }
            })

            onSuccess()
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.UPDATE_PROVIDER_FAILURE)
        }
    }
}
export function resetUpdateProvider() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESET_UPDATE_PROVIDER
        })
    }
}

export function deleteProvider(id) {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.DELETE_PROVIDER })

            const response = await providerService.deleteProvider(id)

            dispatch({
                type: actionTypes.DELETE_PROVIDER_SUCCESS,
                payload: {
                    provider: { id }
                }
            })

            dispatch({ type: actionTypes.RESET_DELETE_PROVIDER })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.DELETE_PROVIDER_FAILURE)
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/provider/actions.js